import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import api from "../api/api";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { ProgressBar } from "primereact/progressbar";
import { Knob } from "primereact/knob";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { Divider } from "primereact/divider";
import * as XLSX from "xlsx";
import { Toast } from "primereact/toast";
import { Calendar } from "primereact/calendar";



export default function Members() {

  const toast = useRef(null);

  const [activeMembers, setActiveMembers] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [loading, setLoading] = useState(false);

  const [workingDailyStepsData, setWorkingDailyStepsData] = useState(0);
  const [nonWorkingDailyStepsData, setNonWorkingDailyStepsData] = useState(0);
  const [workingWeeklyData, setWorkingWeeklyData] = useState([]);
  const [nonWorkingWeeklyData, setNonWorkingWeeklyData] = useState([]);
  const [workingMonthlyData, setWorkingMonthlyData] = useState([]);
  const [nonWorkingMonthlyData, setNonWorkingMonthlyData] = useState([]);

  const [workingMyActivityDailyStepsData, setWorkingMyActivityDailyStepsData] = useState(0);
  const [workingMyActivityTimeInMinutes, setWorkingMyActivityTimeInMinutes] = useState(0);
  const [workingMyActivityDailyTimeData, setWorkingMyActivityDailyTimeData] = useState(0);
  const [nonWorkingMyActivityDailyStepsData, setNonWorkingMyActivityDailyStepsData] = useState(0);
  const [nonWorkingMyActivityTimeInMinutes, setNonWorkingMyActivityTimeInMinutes] = useState(0);
  const [nonWorkingMyActivityDailyTimeData, setNonWorkingMyActivityDailyTimeData] = useState(0);
  const [workingMyActivityWeeklyData, setWorkingMyActivityWeeklyData] = useState([]);
  const [nonWorkingMyActivityWeeklyData, setNonWorkingMyActivityWeeklyData] = useState([]);
  const [workingMyActivityMonthlyData, setWorkingMyActivityMonthlyData] = useState([]);
  const [nonWorkingMyActivityMonthlyData, setNonWorkingMyActivityMonthlyData] = useState([]);
  const [workingMyActivityMonthlyTimeData, setWorkingMyActivityMonthlyTimeData] = useState([]);



  const [date, setDate] = useState(null);
  const [selectedRegistrationDate, setSelectedRegistrationDate] = useState(null);

  // Calculate maxDate as the current date
  const maxDate = new Date();


  const targetSteps = 8000;
  const UserId = sessionStorage.getItem("UserID");
  const Password = sessionStorage.getItem("Password");

  const getActiveMembersData = async () => {
    try {
      setLoading(true);
      const requestData = {
        userid: UserId,
        password: Password,
        synceddatetime: "2023-01-24 11:57:34",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getActiveMembers(requestData);
      if (result && result.status === 200) {
        const dataWithSerialNumbers = result.data.dashboard_count.map(
          (item, index) => ({
            ...item,
            slno: index + 1,
          })
        );
        setActiveMembers(dataWithSerialNumbers);
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getActiveMembersData();
  }, []);



  const getDailyWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "1",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getDailyData(requestData);
      if (result && result.status === 200) {
        const details =
          result.data.loged_in_details.length > 0
            ? result.data.loged_in_details[0]
            : null;
        setWorkingDailyStepsData(details ? details.counts : 0);
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const getDailyNonWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "2",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getDailyData(requestData);
      if (result && result.status === 200) {
        const details =
          result.data.loged_in_details.length > 0
            ? result.data.loged_in_details[0]
            : null;
        setNonWorkingDailyStepsData(details ? details.counts : 0);
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const getWeeklyWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "1",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getWeeklyData(requestData);
      // console.log("result", result);
      if (result && result.status === 200) {
        const getWeekData = result.data.loged_in_details.map((entry) => ({
          Day: entry.day_of_week,
          Steps: entry.day_wise_step_count,
          Duration: entry.fld_time,
        }));
        // console.log("week", getWeekData);
        setWorkingWeeklyData(getWeekData);
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const getWeeklyNonWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "2",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getWeeklyData(requestData);
      if (result && result.status === 200) {
        const getWeekData = result.data.loged_in_details.map((entry) => ({
          Day: entry.day_of_week,
          Steps: entry.day_wise_step_count,
          Duration: entry.fld_time,
        }));
        // console.log("week", getWeekData);
        setNonWorkingWeeklyData(getWeekData);
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const getMonthlyWorkingStepsData = async (email, fld_date_of_registration) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        fld_date_of_registration: fld_date_of_registration,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "1",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMonthlyData(requestData);
      if (result && result.status === 200) {
        const responseData = result.data.loged_in_details;
        // console.log("monthly data res",result)
        // console.log("monthly data", responseData);
        setWorkingMonthlyData(responseData);
      } else {
        console.error("Unexpected API response format:", result);
        setWorkingMonthlyData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
      setWorkingMonthlyData([]);
    } finally {
      setLoading(false);
    }
  };

  const getMonthlyNonWorkingStepsData = async (email, fld_date_of_registration) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        fld_date_of_registration:fld_date_of_registration,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "2",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMonthlyData(requestData);

      if (result && result.status === 200) {
        const responseData = result.data.loged_in_details;
        setNonWorkingMonthlyData(responseData);
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const getBackgroundColor = (date, data) => {
    if (!Array.isArray(data)) return "";
    const formattedDate = format(date, "yyyy-MM-dd");
    const dayData = data.find((d) => d.date === formattedDate);

    if (dayData) {
      if (dayData.day_wise_step_count >= targetSteps) {
        return "#00C851"; // Target achieved
      } else if (dayData.day_wise_step_count >= targetSteps / 2) {
        return "#FFB71B"; // Half of the target achieved
      } else {
        return "#FF4444"; // Below half the target
      }
    }
    return ""; // Default color if no data
  };

  const renderDayContents = (day, date, data) => {
    const bgColor = getBackgroundColor(date, data);
    const dayData = data.find((d) => d.date === format(date, "yyyy-MM-dd"));
    const tooltipText = dayData
      ? `${dayData.day_wise_step_count.toLocaleString()} steps on ${dayData.day_of_week}`
      : "";

    return (
      <div className="calendar-day-wrapper">
        <div
          className="calendar-day"
          style={{
            backgroundColor: bgColor,
            color: bgColor ? "white" : "black",
            borderRadius: "50%",
            width: "2rem",
            height: "2rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: tooltipText ? "pointer" : "default",
          }}
        >
          {day}
        </div>
        {tooltipText && <div className="tooltip">{tooltipText}</div>}
      </div>
    );
  };


  const getTimeBackgroundColor = (date, data) => {
  if (!Array.isArray(data)) return "";
  const formattedDate = format(date, "yyyy-MM-dd");
  const dayData = data.find((d) => d.date === formattedDate);

  if (dayData) {
    const timeInMinutes = convertTimeToMinutes(dayData.fld_total_minutes_walk);

    if (timeInMinutes >= 45) {
      return "#00C851"; // Green: ≥ 45 minutes
    } else if (timeInMinutes >= 30) {
      return "#FFB71B"; // Yellow: 30–44 minutes
    } else if (timeInMinutes >= 15) {
      return "#FD7E14"; // Orange: 15–29 minutes
    } else {
      return "#FF4444"; // Red: < 15 minutes
    }
  }
  return ""; // Default color if no data
};
const convertTimeToMinutes = (time) => {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 60 + minutes + seconds / 60;
};

const renderTimeDayContents = (day, date, data) => {
  const bgColor = getTimeBackgroundColor(date, data);
  const dayData = data.find((d) => d.date === format(date, "yyyy-MM-dd"));
  const tooltipText = dayData
    ? `Walk Duration: ${dayData.fld_total_minutes_walk} on ${dayData.day_of_week}`
    : "";

  return (
      <div className="calendar-day-wrapper">
        <div
          className="calendar-day"
          style={{
            backgroundColor: bgColor,
            color: bgColor ? "white" : "black",
            borderRadius: "50%",
            width: "2rem",
            height: "2rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: tooltipText ? "pointer" : "default",
          }}
        >
          {day}
        </div>
        {tooltipText && <div className="tooltip">{tooltipText}</div>}
      </div>
  );
};

  const getMyActivityDailyWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "3",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMyActivityDailyData(requestData);
      if (result && result.status === 200) {
        const details =
          result.data.loged_in_details.length > 0
            ? result.data.loged_in_details[0]
            : null;
  
        setWorkingMyActivityDailyStepsData(details ? details.counts : 0);
  
        if (details && details.timing) {
          // Parse timing for Knob value
          const [hours, minutes, seconds] = details.timing.split(":").map(Number);
          const totalMinutes = hours * 60 + minutes + seconds / 60;
  
          setWorkingMyActivityTimeInMinutes(totalMinutes); // For Knob
          setWorkingMyActivityDailyTimeData(details.timing); // Original format
        } else {
          setWorkingMyActivityTimeInMinutes(0);
          setWorkingMyActivityDailyTimeData("00:00:00");
        }
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const getKnobColor = (timeInMinutes) => {
  if (timeInMinutes >= 45) return "#28A745"; // Green
  if (timeInMinutes >= 30) return "#FFC107"; // Yellow
  if (timeInMinutes >= 15) return "#FD7E14"; // Orange
  return "#DC3545"; // Red
};

  const getMyActivityDailyNonWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "4",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMyActivityDailyData(requestData);
      if (result && result.status === 200) {
        const details =
          result.data.loged_in_details.length > 0
            ? result.data.loged_in_details[0]
            : null;
  
            setNonWorkingMyActivityDailyStepsData(details ? details.counts : 0);
  
        if (details && details.timing) {
          // Parse timing for Knob value
          const [hours, minutes, seconds] = details.timing.split(":").map(Number);
          const totalMinutes = hours * 60 + minutes + seconds / 60;
  
          setNonWorkingMyActivityTimeInMinutes(totalMinutes); // For Knob
          setNonWorkingMyActivityDailyTimeData(details.timing); // Original format
        } else {
          setNonWorkingMyActivityTimeInMinutes(0);
          setNonWorkingMyActivityDailyTimeData("00:00:00");
        }
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const getMyActivityWeeklyWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "3",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMyActivityWeeklyData(requestData);
      if (result && result.status === 200) {
        const getWeekData = result.data.loged_in_details.map((entry) => {
          const [hours, minutes, seconds] = entry.fld_time
            .split(":")
            .map(Number);
          const totalMinutes = hours * 60 + minutes + seconds / 60; // Convert to numeric format
  
          return {
            Day: entry.day_of_week,
            Steps: entry.day_wise_step_count,
            Duration: totalMinutes , // Use total minutes for the chart
          };
        });
        setWorkingMyActivityWeeklyData(getWeekData);
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };
  
  const getMyActivityWeeklyNonWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "4",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMyActivityWeeklyData(requestData);
      if (result && result.status === 200) {
        const getWeekData = result.data.loged_in_details.map((entry) => {
          const [hours, minutes, seconds] = entry.fld_time
            .split(":")
            .map(Number);
          const totalMinutes = hours * 60 + minutes + seconds / 60; // Convert to numeric format
  
          return {
            Day: entry.day_of_week,
            Steps: entry.day_wise_step_count,
            Duration: totalMinutes , // Use total minutes for the chart
          };
        });
        setNonWorkingMyActivityWeeklyData(getWeekData);
      } else {
        console.error("Unexpected API response format:", result);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const getMyActivityMonthlyWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "3",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMyActivityMonthlyData(requestData);
      if (result && result.status === 200) {
        const responseData = result.data.loged_in_details;
        setWorkingMyActivityMonthlyData(responseData);
      } else {
        console.error("Unexpected API response format:", result);
        setWorkingMyActivityMonthlyData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
      setWorkingMyActivityMonthlyData([]);
    } finally {
      setLoading(false);
    }
  };

  const getMyActivityMonthlyNonWorkingStepsData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "4",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMyActivityMonthlyData(requestData);
      if (result && result.status === 200) {
        const responseData = result.data.loged_in_details;
        setNonWorkingMyActivityMonthlyData(responseData);
      } else {
        console.error("Unexpected API response format:", result);
        setNonWorkingMyActivityMonthlyData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
      setNonWorkingMyActivityMonthlyData([]);
    } finally {
      setLoading(false);
    }
  };

    const getMyActivityMonthlyWorkingTimeData = async (email) => {
    try {
      setLoading(true);
      const requestData = {
        fld_email: email,
        synceddatetime: "10-12-2024 10:15:32",
        working_status: "3",
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "1",
        AppVersion: "1.0.0",
        DbVersion: "10.4.1",
        DbSource: "W",
      };
      const result = await api.getMyActivityMonthlyTimeData(requestData);
      if (result && result.status === 200) {
        const responseData = result.data.loged_in_details;
        setWorkingMyActivityMonthlyTimeData(responseData);
      } else {
        console.error("Unexpected API response format:", result);
        setWorkingMyActivityMonthlyTimeData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
      setWorkingMyActivityMonthlyTimeData([]);
    } finally {
      setLoading(false);
    }
  };

    const parseTimeToMinutes = (time) => {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      return hours * 60 + minutes + seconds / 60;
    };




  const viewButtonTemplate = (rowData) => {
    return (
      <div className="flex gap-3">
      <Button
        label="View"
        className="viewButton"
        icon="pi pi-external-link"
        onClick={() => {
          setSelectedMember(rowData);
          setVisible(true);
          console.log("Selected Member:", rowData.fld_name);
          getDailyWorkingStepsData(rowData.fld_email);
          getDailyNonWorkingStepsData(rowData.fld_email);
          getWeeklyWorkingStepsData(rowData.fld_email);
          getWeeklyNonWorkingStepsData(rowData.fld_email);
          getMonthlyWorkingStepsData(rowData.fld_email, rowData.fld_date_of_registration);
          getMonthlyNonWorkingStepsData(rowData.fld_email, rowData.fld_date_of_registration);
          getMyActivityMonthlyWorkingTimeData(rowData.fld_email);

          getMyActivityDailyWorkingStepsData(rowData.fld_email);
          getMyActivityDailyNonWorkingStepsData(rowData.fld_email);
          getMyActivityWeeklyWorkingStepsData(rowData.fld_email);
          getMyActivityWeeklyNonWorkingStepsData(rowData.fld_email);
          getMyActivityMonthlyWorkingStepsData(rowData.fld_email);
          getMyActivityMonthlyNonWorkingStepsData(rowData.fld_email)
        }}
      />
      </div>
    );
  };
  const shortenedWeeklyWorkingData = workingWeeklyData.map((item) => ({
    ...item,
    Day: item.Day.slice(0, 3),
  }));
  const shortenedWeeklyNonWorkingData = nonWorkingWeeklyData.map((item) => ({
    ...item,
    Day: item.Day.slice(0, 3),
  }));


    const reportButton = (rowData) => {
    return (
      <div className="flex gap-3">
      <Button
        label="Report"
        className="viewButton"
        icon="pi pi-download"
        // onClick={() => { getHourlyStepData(rowData.fld_email) }}
        onClick={() => {
          setVisible1(true);
          setSelectedEmail(rowData.fld_email); // Store the email for the report
          setSelectedRegistrationDate(new Date(rowData.fld_date_of_registration)); // Store the registration date
        }}

      />
      </div>
    );
  };

const [selectedEmail, setSelectedEmail] = useState(null);


const getHourlyStepData = async (email, selectedDate) => {
  try {
    setLoading(true);

    // Extract month and year from the selectedDate
    const month = selectedDate ? selectedDate.getMonth() + 1 : ""; // Months are zero-based
    const year = selectedDate ? selectedDate.getFullYear() : "";

    const requestData = {
      fld_email: email,
      synceddatetime: "10-12-2024 10:15:32",
      MONTH: month.toString().padStart(2, "0"), // Format as two digits
      YEAR: year.toString(),
      FormCode: "201",
      ApiKey: "kavin",
      AppTypeNo: "1",
      AppVersion: "1.0.0",
      DbVersion: "10.4.1",
      DbSource: "W",
    };

    console.log("Fetching data with request:", requestData);
    const result = await api.getMyHourlyData(requestData);
    console.log("Raw API Response:", result);

    const responseData = result?.data;

    console.log("Processed API Response:", responseData);

    if (responseData?.status === "1") {
      if (responseData.dashboard_count.length === 0) {
        toast.current.show({
          severity: "info",
          summary: "No Data",
          detail: "No hourly data available.",
          life: 3000,
        });
      } else {
        downloadExcel(responseData.dashboard_count, responseData.my_activity_data);
      }
    } else {
      console.error("Invalid response data", responseData);
    }
  } catch (error) {
    console.error("Error fetching dashboard data", error);
  } finally {
    setLoading(false);
  }
};

const downloadExcel = (dashboardData, activityData) => {
  try {
    // Format the dashboard data for the first sheet
    const formattedDashboardData = dashboardData.map((item, index) => ({
      "Sl No.": index + 1,
      "Date": item.date_only,
      "Hour": item.hour_am_pm,
      "Step Count": item.stepcount,
    }));

    // Prepare user details for the first sheet
    const userDetails = [
      {
        "Reg Date": dashboardData[0]?.fld_date_of_registration || "N/A",
        "Name": dashboardData[0]?.fld_name || "N/A",
        "Email": dashboardData[0]?.fld_email || "N/A",
        "Contact Number": dashboardData[0]?.fld_contact_number || "N/A",
        "Gender": dashboardData[0]?.fld_gender_name || "N/A",
        "Date of Birth": dashboardData[0]?.fld_date_of_birth || "N/A",
        "Height": dashboardData[0]?.fld_height || "N/A",
        "Weight": dashboardData[0]?.fld_weight || "N/A",
      },
    ];

    // Prepare dashboard sheet with User Details + Dashboard Data
    const dashboardSheet = XLSX.utils.aoa_to_sheet([
      ["User Details"], // Header for User Details
      ["Reg Date", "Name", "Email", "Contact Number", "Gender", "Date of Birth", "Height", "Weight"],
      ...userDetails.map((item) => Object.values(item)),
      [],
      ["Hourly Data"], // Header for Dashboard Data
      ["Sl No.", "Date", "Hour",  "Step Count"],
      ...formattedDashboardData.map((item) => Object.values(item)),
    ]);

    // Merge the header rows
    dashboardSheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, // Merge "User Details"
      { s: { r: 4, c: 0 }, e: { r: 4, c: 3 } }, // Merge "Dashboard Data"
    ];

    // Prepare activity data for the second sheet
    const activityDetails = activityData.map((item, index) => {
    
      return {
        "Sl No.": index + 1,
        "Date": item.date_only,
        "Hour": item.hour_am_pm,
        "Start Time": item.fld_start_time,
        "Stop Time": item.fld_end_time,
        "Total Time Duration": item.time_duration,
        "Step Count": item.stepcount,
      };
    });

    const activitySheet = XLSX.utils.aoa_to_sheet([
      ["User Details"], // Header for User Details
      ["Reg Date", "Name", "Email", "Contact Number", "Gender", "Date of Birth", "Height", "Weight"],
      ...userDetails.map((item) => Object.values(item)),
      [],
      ["Activity Details"], // Header for Activity Details
      ["Sl No.", "Date", "Hour", "Start Time", "Stop Time", "Total Time Duration", "Step Count"],
      ...activityDetails.map((item) => Object.values(item)),
    ]);

    // Merge the header rows
    activitySheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, // Merge "User Details"
      { s: { r: 4, c: 0 }, e: { r: 4, c: 6 } }, // Merge "Activity Details"
    ];

    // Create workbook and add sheets
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, dashboardSheet, "Hourly Steps");
    XLSX.utils.book_append_sheet(workbook, activitySheet, "Activity Details");

    // Write the Excel file
    XLSX.writeFile(workbook, "Hourly_User_Step_Count.xlsx");
  } catch (err) {
    console.error("Error downloading Excel", err);
  }
};




  return (
    <div className="p-2">
      <Toast ref={toast} />
      <Dialog
        header={
          selectedMember ? (
            <span style={{ paddingLeft: "10px" }}>
              <span
                style={{
                  color: "#7265e2",
                  fontWeight: "bold",
                  paddingRight: "5px",
                }}
              >
                {selectedMember.fld_name}'s
              </span>
              Dashboard
            </span>
          ) : (
            "User Dashboard"
          )
        }
        visible={visible}
        style={{ width: '99%', minHeight:"98%" }}
        onHide={() => {
          setVisible(false);
          setSelectedMember(null);
        }}
      >
        <div className="row mt-4">
          <div className="col-6">
            <div className="card">
              <h5 className="card-header">Today's - Working hours</h5>
              <div className="card-body flex justify-content-around">
                <div style={{textAlign:"center"}}>
                  <div style={{ position: "relative" }}>
                    <Knob
                      value={Math.min(workingDailyStepsData, 4000)}
                      max={4000}
                      size={200}
                      strokeWidth={8}
                      readOnly
                      valueColor="#FB923C"
                      rangeColor="#DEE2E6"
                      showValue={false}
                    />
                    <div className="knob-data">
                      {workingDailyStepsData}{" "}
                    </div>
                  </div>
                  <span style={{ fontSize: "1.2rem" }}>
                    Steps
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="card">
              <h5 className="card-header">
                Today's - Non-Working hours{" "}
              </h5>
              <div className="card-body flex justify-content-around">
                   <div style={{textAlign:"center"}}>
                  <div style={{ position: "relative" }}>
                    <Knob
                      value={Math.min(nonWorkingDailyStepsData, 4000)}
                      max={4000}
                      size={200}
                      strokeWidth={8}
                      readOnly
                      valueColor="#FB923C"
                      rangeColor="#DEE2E6"
                      showValue={false}
                    />
                    <div className="knob-data">
                      {nonWorkingDailyStepsData}{" "}
                    </div>
                  </div>
                  <span style={{ fontSize: "1.2rem" }}>
                    Steps
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-6">
            <div className="card">
              <h5 className="card-header">Today's My Activity - Working hours</h5>
              <div className="card-body flex justify-content-around">
                <div style={{textAlign:"center"}}>
                  <div style={{ position: "relative" }}>
                    <Knob
                      value={Math.min(workingMyActivityDailyStepsData, 4000)}
                      max={4000}
                      size={200}
                      strokeWidth={8}
                      readOnly
                      valueColor="#FB923C"
                      rangeColor="#DEE2E6"
                      showValue={false}
                    />
                    <div className="knob-data">
                      {workingMyActivityDailyStepsData}{" "}
                    </div>
                  </div>
                  <span style={{ marginTop: "20px", fontSize: "1.2rem" }}>
                    Steps
                  </span>
                </div>
                <div style={{textAlign:"center"}}>
                  <div style={{ position: "relative" }}>
                    <Knob
                      value={Math.min(workingMyActivityTimeInMinutes, 45)}
                      max={45}
                      size={200}
                      strokeWidth={8}
                      readOnly
                      valueColor={getKnobColor(workingMyActivityTimeInMinutes)}
                      rangeColor="#DEE2E6"
                      showValue={false}
                    />
                    <div className="knob-data">
                      {workingMyActivityDailyTimeData}{" "}
                    </div>
                  </div>
                  <span style={{ marginTop: "20px", fontSize: "1.2rem" }}>
                  Duration
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="card">
              <h5 className="card-header"> Today's My Activity - Non-Working hours{" "}</h5>
              <div className="card-body flex justify-content-around">
                   <div style={{textAlign:"center"}}>
                  <div style={{ position: "relative" }}>
                    <Knob
                      value={Math.min(nonWorkingMyActivityDailyStepsData, 4000)}
                      max={4000}
                      size={200}
                      strokeWidth={8}
                      readOnly
                      valueColor="#FB923C"
                      rangeColor="#DEE2E6"
                      showValue={false}
                    />
                    <div className="knob-data">
                      {nonWorkingMyActivityDailyStepsData}{" "}
                    </div>
                  </div>
                  <span style={{ marginTop: "20px", fontSize: "1.2rem" }}>
                    Steps
                  </span>
                </div>
                    <div style={{textAlign:"center"}}>
                  <div style={{ position: "relative" }}>
                    <Knob
                      value={Math.min(nonWorkingMyActivityTimeInMinutes, 45)}
                      max={45}
                      size={200}
                      strokeWidth={8}
                      readOnly
                      valueColor={getKnobColor(nonWorkingMyActivityTimeInMinutes)}
                      rangeColor="#DEE2E6"
                      showValue={false}
                    />
                    <div className="knob-data">
                      {nonWorkingMyActivityDailyTimeData}{" "}
                    </div>
                  </div>
                  <span style={{ marginTop: "20px", fontSize: "1.2rem" }}>
                  Duration
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Divider/>


        <div className="row">
          <div className="col-6">
            <div className="card">
              <h5 className="card-header">Weekly - Working hours</h5>
              <div className="card-body">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart
                    data={shortenedWeeklyWorkingData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    barSize={30}
                  >
                    <XAxis dataKey="Day" stroke="#8884d8" />
                    <YAxis stroke="#8884d8" />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Steps" fill="#8676FE" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>


          <div className="col-6">
            <div className="card">
              <h5 className="card-header"> Weekly - Non-Working hours</h5>
              <div className="card-body">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart
                    data={shortenedWeeklyNonWorkingData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    barSize={30}
                  >
                    <XAxis dataKey="Day" stroke="#8884d8" />
                    <YAxis stroke="#8884d8" />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Steps" fill="#8676FE" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="card">
              <h5 className="card-header">Weekly My Activity - Working hours</h5>
              <div className="card-body">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart
                    data={workingMyActivityWeeklyData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    barSize={30}
                  >
                    <XAxis dataKey="Day" stroke="#8884d8" />
                    <YAxis stroke="#8884d8" />
                    <Tooltip
                      formatter={(value, name) => {
                        if (name === "Duration") {
                          const formattedValue = parseFloat(value).toFixed(2); // Round to 2 decimal places
                          return [`${formattedValue} min`, "Duration"];
                        }
                        return [value, name];
                      }}
                    />
                    <Legend />
                    <Bar dataKey="Steps" fill="#8676FE" />
                    <Bar dataKey="Duration" fill="#FB7748" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>


          <div className="col-6">
            <div className="card">
              <h5 className="card-header">  Weekly My Activity - Non-Working hours</h5>
              <div className="card-body">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart
                    data={nonWorkingMyActivityWeeklyData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    barSize={30}
                  >
                    <XAxis dataKey="Day" stroke="#8884d8" />
                    <YAxis stroke="#8884d8" />
                    <Tooltip
                      formatter={(value, name) => {
                        if (name === "Duration") {
                          const formattedValue = parseFloat(value).toFixed(2); // Round to 2 decimal places
                          return [`${formattedValue} min`, "Duration"];
                        }
                        return [value, name];
                      }}
                    />
                    <Legend />
                    <Bar dataKey="Steps" fill="#8676FE" />
                    <Bar dataKey="Duration" fill="#FB7748" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>

      <Divider/>


        <div className="row">
          <div className="col-6">
            <div className="card">
              <h5 className="card-header">Monthly - Working hours</h5>
              <div className="card-body flex justify-content-around">
                <DatePicker
                  dayClassName={(date) => {
                    const bgColor = getBackgroundColor(date, workingMonthlyData);
                    return bgColor ? `highlight-${bgColor}` : "";
                  }}
                  inline
                  filterDate={() => false}
                  renderDayContents={(day, date) =>
                    renderDayContents(day, date, workingMonthlyData)
                  }
                />
              </div>
            </div>
          </div>
          
          <div className="col-6">
            <div className="card">
              <h5 className="card-header"> Monthly - Non-Working hours{" "}</h5>
              <div className="card-body flex justify-content-around">
                  <DatePicker
                    dayClassName={(date) => {
                      const bgColor = getBackgroundColor(date, nonWorkingMonthlyData);
                      return bgColor ? `highlight-${bgColor}` : "";
                    }}
                    inline
                    filterDate={() => false}
                    renderDayContents={(day, date) =>
                      renderDayContents(day, date, nonWorkingMonthlyData)
                    }
                  />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="card">
              <h5 className="card-header">Monthly My Activity - Working hours - Steps</h5>
              <div className="card-body flex justify-content-around">
                <DatePicker
                  dayClassName={(date) => {
                    const bgColor = getBackgroundColor(date, workingMyActivityMonthlyData);
                    return bgColor ? `highlight-${bgColor}` : "";
                  }}
                  className="two-calender"
                  inline
                  filterDate={() => false}
                  renderDayContents={(day, date) =>
                    renderDayContents(day, date, workingMyActivityMonthlyData)
                  }
                />
              </div>
            </div>
          </div>
          
          <div className="col-6">
            <div className="card">
              <h5 className="card-header"> Monthly My Activity - Working hours - Duration(hh:mm:ss)</h5>
              <div className="card-body flex justify-content-around">
                  <DatePicker
                    dayClassName={(date) => {
                      const bgColor = getTimeBackgroundColor(date, workingMyActivityMonthlyTimeData);
                      return bgColor ? `highlight-${bgColor}` : "";
                    }}
                  className="two-calender"
                    inline
                    filterDate={() => false}
                    renderDayContents={(day, date) =>
                      renderTimeDayContents(day, date, workingMyActivityMonthlyTimeData)
                    }
                  />
              </div>
            </div>
          </div>
        </div>


        <div className="row">
          <div className="col-6">
            <div className="card">
              <h5 className="card-header"> Monthly My Activity - Non-Working hours{" "}</h5>
              <div className="card-body flex justify-content-around">
                  <DatePicker
                    dayClassName={(date) => {
                      const bgColor = getBackgroundColor(date, nonWorkingMyActivityMonthlyData);
                      return bgColor ? `highlight-${bgColor}` : "";
                    }}
                    inline
                    filterDate={() => false}
                    renderDayContents={(day, date) =>
                      renderDayContents(day, date, nonWorkingMyActivityMonthlyData)
                    }
                  />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      <span className="heading-page pt-4" style={{fontSize:"26px"}}>No. Members</span>
      {loading && (
        <div className="pro-spin">
          <ProgressSpinner
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#7265e2",
            }}
          />
        </div>
      )}
      <div className="card mt-2">
        <DataTable
          value={activeMembers}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          tableStyle={{ minWidth: "50rem" }}
        >
          <Column field="slno" header="Sl.No" />
          <Column field="fld_name" header="Name" ></Column>
          <Column field="fld_email" header="Email" ></Column>
          <Column field="fld_gender_name" header="Gender" ></Column>
          <Column field="fld_date_of_birth" header="DOB" ></Column>
          <Column field="fld_height" header="Height" ></Column>
          <Column field="fld_weight" header="Weight" ></Column>
          <Column body={viewButtonTemplate} header="Dashboard" ></Column>
          <Column body={reportButton} header="Report" ></Column>


        </DataTable>
      </div>

      <Dialog
        header="Report Download"
        visible={visible1}
        onHide={() => {
          setVisible1(false);
          setSelectedRegistrationDate(null);
        }}
        style={{borderRadius:"20px"}}
      >
        <>
          Month/Year :     <Calendar
            value={date}
            onChange={(e) => setDate(e.value)}
            view="month"
            dateFormat="mm/yy"
            placeholder="Select"
            minDate={selectedRegistrationDate} // Set minDate dynamically
            maxDate={maxDate} // Set maxDate to current date
            style={{borderRadius:"20px"}}
          />
          <div className="flex justify-content-end">
          <Button
            label="Download"
            className="viewButton mt-3"
            icon="pi pi-download"
                    onClick={() => {
          if (date && selectedEmail) {
            getHourlyStepData(selectedEmail, date);
            setVisible1(false);
            setDate(null)
          } else {
            toast.current.show({
              severity: "warn",
              summary: "Missing Information",
              detail: "Please select a month/year and email.",
              life: 3000,
            });
          }
        }}
          />
          </div>

        </>

      </Dialog>
    </div>
  );
}
